const fa = {
  app: {
    name: 'ریکو'
  },
  common: {
    all: 'همه',
    allDepartments: 'همه دپارتمان‌ها',
    anonymous: 'ناشناس',
    cancel: 'انصراف',
    confirm: 'تایید',
    creditLabel: 'اعتبار:',
    delete: 'حذف',
    edit: 'ویرایش',
    end: 'پایان',
    error: 'مشکلی پیش اومده!',
    errorFormal: 'مشکلی پیش آمده',
    errorPlain: 'مشکلی پیش اومده',
    errorOccurred: 'خطایی رخ داده است',
    exit: 'خروج',
    more: 'موارد بیشتر',
    myDepartment: 'دپارتمان من',
    next: 'بعدی',
    other: 'سایر',
    previous: 'قبلی',
    scoreLabel: 'امتیاز:',
    skip: 'رد کردن',
    statusLabel: 'وضعیت:',
    submit: 'ثبت',
    today: 'امروز',
    tomorrow: 'فردا',
    user: 'کاربر'
  },
  nav: {
    announcements: 'اطلاعیه',
    back: 'بازگشت به صفحه‌ی قبل',
    conversations: 'گفت‌و‌گو',
    giveKudos: 'به همکارت ریکو بده!',
    help: 'راهنما',
    home: 'خانه',
    moodTracker: 'مودترکر',
    notifications: 'نوتیفیکیشن',
    occasions: 'مناسبت‌ها',
    rewards: 'جوایز',
    search: 'جست‌وجو',
    surveys: 'سیگنال'
  },
  settings: {
    title: 'تنظیمات',
    notifications: 'تنظیمات نوتفیکیشن',
    changePassword: 'تغییر گذرواژه',
    privacy: 'قوانین و سیاست حریم خصوصی',
    language: 'زبان',
    notifyKudos: 'ریکو جدید گرفتم باخبر بشم!',
    notifyAnnouncement: 'اطلاعیه‌ی جدید اومد باخبر بشم!',
    notifyConversation: 'کسی ازم گفت‌و‌گو خواست باخبر بشم!',
    notifyMoodReminder: 'پرسش مود روزانه!'
  },
  changePassword: {
    success: 'گذرواژه‌ی شما با موفقیت تغییر یافت',
    mismatch: 'مقدار واردشده با گذرواژه‌ی جدید مطابقت ندارد',
    old: 'گذرواژه‌ی قدیمی',
    new: 'گذرواژه‌ی جدید',
    repeat: 'تکرار گذرواژه',
    invalidChars: 'گذرواژه باید شامل حروف و اعداد انگلیسی و علائم مجاز باشد'
  },
  auth: {
    loginSuccess: 'با موفقیت وارد شدی!',
    username: 'نام کاربری',
    password: 'گذرواژه',
    login: 'ورود',
    forgotPassword: 'فراموشی گذرواژه',
    registerWelcome: 'به صفحه ثبت نام ریکو خوش آمدید!',
    passwordMismatch: 'تایید کلمه عبور با کلمه عبور وارد شده یکسان نیست',
    enterNewPassword: 'گذرواژه جدید را وارد کنید',
    confirmPassword: 'تایید گذرواژه',
    newPassword: 'گذرواژه جدید',
    registerPassword: 'کلمه عبور',
    registerConfirmPassword: 'تایید کلمه عبور',
    enterPhone: 'لطفا شماره همراه خود را وارد کنید',
    phone: 'شماره همراه',
    confirmPhone: 'تایید شماره همراه',
    enterCode: 'کد پنج رقمی که برای شماره زیر پیامک شده است را وارد کنید',
    resendIn: '{time} مانده تا دریافت مجدد کد',
    resendCode: 'دریافت مجدد کد',
    changePhone: 'تعویض شماره همراه',
    registered: 'با موفقیت ثبت نام شدید:)',
    enterRegisterInfo: 'اطلاعات خود را برای ثبت نام وارد کنید',
    firstName: 'نام',
    lastName: 'نام خانوادگی',
    register: 'ثبت نام'
  },
  notifications: {
    title: 'نوتیفیکیشن‌ها',
    allSeenToast: 'همه دیده‌ شده!',
    tabNotifications: 'اعلان',
    tabTodos: 'کارها',
    undone: 'انجام نشده‌ها',
    done: 'انجام شده‌ها',
    markAllSeen: 'همه رو دیدم!',
    empty: 'هیچ نوتفیکیشنی وجود نداره',
    emptyTodos: 'هیچ کاری وجود نداره'
  },
  home: {
    title: 'داشبورد',
    news: 'چه خبر؟',
    noAnnouncements: 'هنوز اطلاعیه‌ای ثبت نشده',
    orgMoodAverage: 'میانگین حال سازمان',
    outOfFive: '{value} از 5',
    firstMood: 'اولین نفری باش که حالش رو ثبت می‌کنه...',
    allKudos: 'همه‌ی ریکوها',
    leaderboard: 'ترین‌ها',
    allCards: 'همه ریکارت‌ها',
    generalValues: 'ارزش های عمومی',
    organizationValues: 'ارزش های سازمانی',
    noKudos: 'کسی ریکو نداده',
    notificationAccept: 'آره حتما!',
    notificationReject: 'نه فعلا'
  },
  giveKudos: {
    title: 'ریکو!',
    success: 'با موفقیت ریکو دادی!',
    selected: 'انتخاب کردم',
    groupCost:
      'با اهدای {point} امتیاز به {count} نفر از همکارات، جمعاً {total} امتیاز ({point}×{count}) از اعتبارت کسر می‌شه.',
    groupShortage:
      'برای اهدای {point} امتیاز به {count} نفر از همکارات، به {missing} امتیاز دیگه نیاز داری.',
    whoQuestion: 'به کی می‌خوای ریکو بدی؟',
    selectColleague: 'یکی از همکارهات رو انتخاب کن',
    whichColleague: 'به کدوم همکارت ریکو می‌دی؟',
    forWhat: 'بابت چی؟',
    howMany: 'چند امتیاز؟',
    maxCoin: 'حداکثر امتیاز این ریکارت {max} است.',
    whichCard: 'کدوم ریکارت؟',
    send: 'بفرست براش',
    examples: {
      kudos: [
        'می‌تونی اینجوری از همکارت قدردانی کنی: \n  محمدجان مرسی که در کنار همه دغدغه‌هات، با غیرت خاصی کارهای تیم رو  دنبال می‌کنی. این کار تو به ما انگیزه میده.',
        'می‌تونی اینجوری از همکارت قدردانی کنی: \n  مریم جان ممنون بابت هماهنگی‌‌ها و تلاشت برای سریع‌تر پیش بردن کارها. چقدر خوبه که هم‌تیم من هستی!',
        'ویژگی‌ مثبت همکار خود را تحسین کن:\n علی جان تو یه پسر خوش سخن و با انرژی و با انگیزه هستی. مرسی از این روحیه! ',
        'از کسی که کمکت کرده‌ قدردانی کن:\n زهرای عزیز از این که در تهیه فایل های دوره به من کمک کردی خیلی ممنون',
        'از کسی که کمکت کرده‌ قدردانی کن:\n مهسا جان! حس مسئولیت پذیریت و اینکه علاقه داری به دیگران کمک کنی و مشکلاتشون رو حل کنی، برای من بسیار بسیار ارزشمنده.',
        'از افرادی که از آن‌ها یادگرفته‌ای قدردانی کن:\n مهدی عزیز! مرسی که اینقدر خوشرویی و انرژی مثبت میدی  و از دانشت بی منت به منم یاد میدی :)',
        'از همکاری که صرفا از حضورش انرژی می‌گیری قدردانی کن:\n سارا انرژی مثبتی که به دیگران میدی خیلی خوبه \n خوشحالم همکارت هستم😘😘'
      ],
      anniversary: [
        'می‌تونی این‌طوری سالگرد ورود همکارت به شرکت رو تبریک بگی: \n محمد عزیز؛ سالگرد همکاری‌ات با شرکت‌مون رو تبریک می‌گم و خوشحالم همکار خوش‌فکر و توانمندی مثل تو داریم...',
        'می‌تونی این‌طوری سالگرد ورود همکارت به شرکت رو تبریک بگی: \n نرگس‌جان؛ خوشحالم که یک سال دیگه از همکاری‌مون با تو می‌گذره؛ سالگرد اومدنت به شرکت مبارک! '
      ],
      birthday: [
        'می‌تونی اینجوری تولد همکارت رو تبریک بگی: \n زهرا عزیز تولدت مبارک باشه  امیدوارم همیشه  سالم و سلامت باشی و لبات خندون',
        'می‌تونی اینجوری تولد همکارت رو تبریک بگی: \n علی دوست داشتنی همکار عزیز با اخلاق و پر تلاش تولدت رو تبریک میگم و برات بهترین ها رو آرزومندم  \n ایشالا ۱۲۰ ساله شی '
      ]
    }
  },
  mood: {
    examplePrefix: 'مثلا: \n',
    examples: {
      neutral: [
        'کارهای امروز رو به موقع انجام دادم ، خیلی حس خوبیه',
        'فشار کاری این چند روز زیاد بود و خسته شدم',
        'جلسه‌ی امروز با مدیرم خیلی خوب رفت جلو.',
        'حس می‌کنم کارهام تو شرکت دیده نمیشه 😔',
        'بعد از یک هفته از پیوستنم به اینجا واقعا خوشحالم. محیط خوب، تیم عالی 😃',
        'از داشتن همکاران خوب خوشحالم',
        'جدیدا حس می‌کنم مدیرم  خوب من رو راهنمایی  نمی‌کنه',
        'دیروز سرما خوردم و مجبور شدم امروز رو تو خونه بمونم',
        'بالاخره کرونا رو شکست دادم. بعد یک هفته میتونم برگردم شرکت',
        'چند روزیه اینترنت شرکت ضعیفه. واقعا اعصاب خردکنه.',
        'کاری که یک ماه روی اون وقت گذاشته بودم بالاخره به نتیجه رسید. حس خیلی خوبیه'
      ],
      bad: [
        'انگار مغزم خاموشه، نمی‌دونم چه حسی دارم',
        'هیچی از دستم برنمیاد، فقط دارم تماشا می‌کنم',
        'هر صدایی یه احتمال خطره',
        'همه چی داره اعصابم رو خورد می‌کنه',
        'امروز دلم خیلی گرفته، بی‌دلیل یا با دلیل',
        'دلم برای کسی تنگ شده که دیگه نیست',
        'فکر نمی‌کنم هیچ چیز بهتر شه',
        'حالم دقیقه‌به‌دقیقه عوض می‌شه، خسته‌ام',
        'انگار مغزم کار نمی‌کنه، خسته‌ست',
        'هیچی رو نمی‌تونم تموم کنم',
        'از همه چی بیزارم',
        'احساس می‌کنم هیچ‌کس نمی‌فهمه منو',
        'ذهنم فقط سناریوی بد می‌سازه',
        'همه جا ناامنه'
      ],
      good: [
        'امروز فقط خواستم بی‌حسیمو ببینم، نه قضاوتش کنم',
        'می‌ترسم، ولی دارم کارامو می‌کنم',
        'عصبانیم ولی نمی‌خوام خشمم منو کنترل کنه',
        'غم هست، اما دارم کنارش زندگی می‌کنم',
        'با گریه هم می‌شه یاد کسی رو نگه داشت',
        'امروز فقط تونستم دوش بگیرم. همینم موفقیته',
        'این نوسان طبیعیه. دارم تمرین می‌کنم تحملش کنم',
        'یه دقیقه چشامو بستم، همینم کمکم کرد',
        'امروز فقط تونستم یه کار کوچیکو جلو ببرم',
        'توی این همه نفرت، هنوز یه موزیکی هست که آرومم می‌کنه',
        'امروز یکی یه استیکر فرستاد، دلم گرم شد',
        'دارم تمرین می‌کنم فقط امروز رو ببینم',
        'یه گوشه برای خودم درست کردم که حس امنیت بده'
      ]
    },
    submitted: 'حال شما با موفقیت ثبت شد',
    submittedGreeting: 'با موفقیت حالت رو ثبت کردی!',
    submitError: 'در ثبت حالت مشکلی پیش اومده',
    reasonsError: 'در دریافت دلایل مود مشکلی پیش اومده',
    showNameToHr: 'نام من را به ادمین منابع انسانی نشان بده.',
    hideNameFromHr: 'نام من را به ادمین منابع انسانی نشان نده.',
    todayQuestion: 'امروز حال تو چطوره؟',
    details: 'مشاهده جزییات',
    anonymousHint:
      'خیالت راحت؛ هیچکس اسمت رو نمیبینه مگه اینکه تیک زیر رو بزنی',
    hello: 'سلاااام',
    nowQuestion: 'حس و حالت الان چطوره؟',
    later: 'باشه بعدا',
    orgMood: 'حال سازمان',
    pageTitle: 'حالت چطوره؟',
    orgMoodValue: 'حال سازمان‌: {value}',
    yourMoodValue: 'حال شما: {value}',
    userCount: 'تعداد افراد: {value}',
    unreadMessage: 'پیام ناخوانده',
    messages: 'پیام ها',
    chatExpired: 'چت منقضی شده است.'
  },
  profile: {
    title: 'پروفایل',
    rateSubmitted: 'امتیاز با موفقیت ثبت شد',
    noSkills: 'هنوز مهارتی ثبت نکردی',
    noFavorites: 'هنوز علاقه‌مندی ثبت نکردی',
    noWishes: 'هنوز آرزویی ثبت نکردی',
    giveKudosTo: '!به {name} ریکو بده',
    department: 'دپارتمان {name}',
    profileScore: 'امتیاز پروفایل:',
    noProfileScore: 'امتیازی داده نشده‌:(',
    rateProfile: 'به پروفایل {name} امتیاز بده!',
    aboutMe: 'درباره‌ی من',
    born: 'متولد {date}',
    noAbout: 'هنوز درباره خودت چیزی ننوشتی :(',
    skills: 'مهارت‌ها',
    favorites: 'علاقه‌مندی‌ها',
    wishes: 'آرزوها',
    receivedKudos: 'ریکوهای دریافتی',
    givenKudos: 'ریکو به دیگران',
    noReceivedMine: 'هنوز ریکو نگرفتی :(',
    noReceived: '{name} هنوز ریکو نگرفته :( ',
    noGivenMine: 'هنوز ریکو ندادی :(',
    noGiven: '{name} هنوز ریکو نداده :( '
  },
  editProfile: {
    title: 'ویرایش پروفایل',
    avatarChanged: 'آواتار با موفقیت تغییر کرد!',
    avatarDeleted: 'آواتار با موفقیت حذف شد!',
    saved: 'با موفقیت اطلاعاتت رو ویرایش کردی!',
    choosePhoto: 'انتخاب عکس',
    personalInfo: 'اطلاعات فردی',
    about: 'درباره من',
    birthday: 'تاریخ تولد',
    saveError: 'مشکلی پیش اومده.',
    showBirthYear: 'سال تولد من را نشان بده',
    emptyWishes: 'هنوز آرزویی ثبت نکردی :(',
    emptyFavorites: 'هنوز علاقه‌مندی ثبت نکردی :(',
    emptySkills: 'هنوز مهارتی ثبت نکردی :(',
    contacts: 'راه‌های ارتباطی',
    linkedin: 'لینکدین',
    whatsapp: 'واتس‌اپ',
    telegram: 'تلگرام',
    skype: 'اسکایپ',
    phone: 'شماره‌ی تماس',
    email: 'ایمیل',
    instagram: 'اینستاگرام',
    save: 'ثبت اطلاعات',
    zoom: 'زوم'
  },
  welcome: {
    pageTitle: 'خوش‌آمدگویی',
    avatarAdded: 'آواتار با موفقیت اضافه شد!',
    title: 'به ریکو خوش اومدی!',
    intro:
      'ریکو یه نرم‌افزاره که می‌تونیم با استفاده از اون محیط کاری جذاب‌تری برای خودمون و همکارامون بسازیم، ورود به ریکو به معنای پذیرش',
    introEnd: 'ریکو است.',
    notificationTitle: 'دسترسی نوتیفیکیشن',
    notificationText:
      'برای اینکه ریکو‌ شمارو از درخواست‌ها و پیام قدردانی همکارانتون با خبر کنه، در سوال بعدی گزینه allow انتخاب کنید و اگر سوالی پرسیده نشد روی علامت قفل در بالای صفحه بزنید و دسترسی بدهید.',
    notificationButton: 'دادن دسترسی نوتیفیکیشن',
    profileTitle: 'پروفایلت رو کامل کن!',
    profileText:
      'برای شروع به کار بهتره پروفایلت رو کامل کنیم تا همکارات بتونن راحت‌تر پیدات کنن.',
    uploading: 'در حال آپلود',
    changePhoto: 'تغییر عکس',
    uploadPhoto: 'آپلود عکس',
    doneTitle: 'تبریک!',
    doneText: 'حالا آماده‌ای که به دنیای ریکو قدم بذاری!',
    doneHint:
      'برای جذاب‌تر شدن این مسیر، پیشنهاد می‌کنیم تا پروفایلت رو کامل کنی تا بتونی لذت کار کردن کنار همکارات رو تجربه کنی.',
    goToProfile: 'برو به صفحه‌ی پروفایل'
  },
  occasions: {
    birthdays: 'تولدها',
    anniversaries: 'سالگردهای همکاری',
    congratulate: 'ارسال تبریک',
    birthdaysThisMonth: 'تولدهای این ماه همکاران',
    noBirthdays: 'این ماه تولد هیچ کدوم از همکارات نیست :(',
    todayBirthdays: 'امروز {count} تولدهای امروز',
    upcomingBirthdays: 'تولدهای پیش رو',
    pastBirthdays: 'تولدهای گذشته',
    anniversariesHeader: 'سالگرد های ورود',
    anniversariesThisMonth: 'سالگردهای همکاری این ماه',
    noAnniversaries: 'این ماه سالگرد ورود هیچ کدوم از همکارات نیست :(',
    todayAnniversaries: 'سالگردهای همکاری امروز',
    upcomingAnniversaries: 'سالگردهای همکاری پیش رو',
    pastAnniversaries: 'سالگردهای همکاری گذشته'
  },
  announcements: {
    title: 'اطلاعیه‌ها',
    empty: 'اطلاعیه‌ای وجود نداره :(',
    attachment: 'فایل ضمیمه‌شده'
  },
  conversations: {
    title: 'گفت‌و‌گوها',
    single: 'گفت‌و‌گو',
    request: 'درخواست گفت‌و‌گو',
    empty: 'هنوز گفت‌و‌گویی وجود نداره',
    requestSent: 'با موفقیت درخواست گفت‌و‌گو کردی!',
    uploadFailed: 'فایل‌ها بارگذاری نشدند.',
    startWith: 'شروع گفت‌و‌گو با ...',
    titleOptional: 'عنوان (اختیاری)',
    titlePlaceholder: 'مثلاً: بازخورد درباره همکاری اخیر',
    selectColleague: 'یکی از همکاراتو انتخاب کن',
    message: 'متن پیام',
    messagePlaceholder:
      'چه رفتارهایی رو خوبه شروع کنم؟ \n چه کارهایی رو ادامه بدم؟ \n چه چیزهایی رو متوقف کنم؟',
    attach: 'پیوست فایل',
    maxFiles: 'حداکثر می‌توانید {max} فایل پیوست کنید.',
    send: 'بفرست براش!',
    replySent: 'نظر شما با موفقیت ارسال شد.',
    replyFailed: 'ارسال نظر با خطا مواجه شد.',
    downloadFailed: 'دانلود فایل با مشکل مواجه شد.'
  },
  survey: {
    title: 'سیگنال',
    listTitle: 'سیگنال‌ها',
    active: 'سیگنال‌های فعال',
    finished: 'سیگنال‌های به اتمام رسیده',
    emptyActive: 'سیگنال فعالی وجود نداره',
    empty: 'سیگنال وجود نداره',
    deadline: 'فرصت پاسخگویی',
    sent: 'سیگنال با موفقیت ارسال شد.',
    answerRequired: 'لطفا پاسخ خود را وارد کنید.',
    optionRequired: 'لطفا یک گزینه را انتخاب کنید.',
    anonymousNotice: 'جواب شما به این سیگنال به صورت ناشناس ارسال می شود.',
    identifiedNotice: 'جواب شما به این سیگنال با مشخصات شما ارسال می شود.',
    view: 'مشاهده سیگنال',
    start: 'شروع سیگنال',
    sendAnswer: 'ارسال پاسخ',
    sendAnswers: 'ارسال پاسخ‌ها'
  },
  rewards: {
    pageTitle: 'جایزه',
    shop: 'فروشگاه',
    mine: 'جوایز من',
    categories: 'دسته‌بندی‌ها',
    categoriesError: 'در دریافت دسته بندی ها مشکلی پیش اومده',
    claimed: 'مبارکه، جایزه‌تو گرفتی!',
    myRewardsError: 'در دریافت جایزه های شما مشکلی پیش اومده',
    categoryRewardsError: 'در دریافت جایزه های این دسته بندی مشکلی پیش اومده',
    needMore: 'هنوز {count} امتیاز دیگه لازم داری',
    unavailable: 'ناموجود :(',
    want: 'می‌خوامش!',
    shopEmpty: 'فعلاً فروشگاه خالیه',
    categoryEmpty: 'فعلاً این دسته‌بندی خالیه',
    requestDate: 'تاریخ درخواست: {date}',
    hideDescription: 'بستن توضیحات جایزه',
    showDescription: 'نمایش توضیحات جایزه',
    noneYet: 'هنوز جایزه‌ای برای خودت نگرفتی :(',
    codeCopied: 'کد با موفقیت کپی شد!'
  },
  search: {
    placeholder: 'دنبال کدوم همکارت می‌گردی؟',
    department: 'دپارتمان',
    noResult: 'نتیجه‌‌ای یافت نشد :('
  },
  kudos: {
    title: 'ریکو',
    deleted: 'ریکو با موفقیت حذف شد!',
    comments: 'کامنت‌ها',
    likes: 'لایک‌ها',
    noComments: 'هنوز کسی کامنت نذاشته :(',
    noLikes: 'هنوز کسی لایک نکرده :('
  },
  comments: {
    sent: 'با موفقیت کامنتت رو ثبت کردی',
    deleted: 'کامنت شما با موفقیت حذف شد',
    edited: 'کامنت شما با موفقیت ویرایش شد',
    empty: 'هنوز کسی کامنتی نذاشته :(',
    placeholder: 'نظرت رو بنویس',
    reply: 'پاسخ‌'
  },
  leaderboard: {
    receiver: 'ریکوگیرنده',
    sender: 'ریکودهنده',
    receivers: 'ریکوگیرنده‌ها',
    senders: 'ریکودهنده‌ها',
    empty: 'هنوز کسی ریکو نداده :('
  },
  changeLog: {
    title: 'آخرین تغییرات ورژن {version}',
    gotIt: 'متوجه شدم'
  },
  dialogs: {
    notificationAccess: {
      question:
        'آیا ریکو‌ شمارو از درخواست‌ها و پیام قدردانی همکارانتون با خبر کنه؟',
      hint: 'در سوال بعدی گزینه allow انتخاب کنید و اگر سوالی پرسیده نشد روی علامت قفل در بالای صفحه بزنید و دسترسی بدهید.'
    },
    rejectConversation: 'درخواستش رو رد می‌کنی؟'
  }
};

export default fa;
